import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface RatingStarProps {
  style?: React.CSSProperties;
}

export default function BugReportIcon({ style = {}, ...props }: RatingStarProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 48 48" style={{ width: `24px`, height: `24px`, ...style }}>
      <path
        fill={RoutalPalette.neutral60}
        d="M43.02,31.69c.03-.06,.06-.12,.09-.18,.02-.06,.04-.12,.06-.19,.02-.06,.04-.12,.05-.18,.01-.07,.02-.15,.02-.22,0-.05,.01-.1,.01-.15V4.92s0-.05,0-.08c0-.17,0-.34-.05-.51-.25-1.08-1.33-1.74-2.41-1.49l-3.69,.87c-2.85,.67-5.83,.54-8.6-.38l-5.73-1.9c-2.94-.98-6.11-1.25-9.18-.79L6.45,1.71c-1.09,.16-1.84,1.18-1.68,2.27h0c-.01,.09-.02,.17-.02,.26V45.59c0,1.1,.9,2,2,2s2-.9,2-2v-14.2l5.43-.82c2.45-.37,4.98-.15,7.32,.63l5.73,1.91c2.02,.67,4.13,1.01,6.24,1.01,1.52,0,3.05-.18,4.55-.53l3.7-.87s.08-.03,.13-.04c.08-.02,.15-.05,.23-.08,.06-.02,.11-.06,.16-.09,.06-.03,.12-.07,.18-.1,.05-.04,.1-.08,.15-.12,.05-.04,.1-.08,.14-.13,.04-.05,.08-.1,.12-.15,.04-.05,.08-.1,.12-.16,.03-.05,.06-.11,.09-.16Zm-5.92-1.99c-2.85,.67-5.82,.54-8.6-.38l-5.73-1.91c-2.94-.98-6.12-1.25-9.18-.79l-4.83,.73V5.4l5.43-.82c2.45-.37,4.98-.15,7.32,.63l5.73,1.9c2.02,.67,4.13,1.01,6.24,1.01,1.52,0,3.05-.18,4.55-.53l1.24-.29V29.19l-2.16,.51Z"
      />
    </SvgIcon>
  );
}
